import { AgentApiRequestHelper } from '../agent-api-request-helper';
import type { CommendaAiMutationResult } from '../types';
import type { IAbortDocumentReaderUploadResponse } from './types';

/** Stops an unfinished data-room upload; files already stored stay. */
export async function abortDocumentReaderUpload(
  uploadId: string
): Promise<CommendaAiMutationResult<IAbortDocumentReaderUploadResponse>> {
  return AgentApiRequestHelper.mutate<IAbortDocumentReaderUploadResponse>(
    `agent-platform/document-reader/uploads/${encodeURIComponent(uploadId)}/abort`,
    { method: 'POST' },
    'Could not cancel the data room upload.'
  );
}
